import { NavLink } from 'react-router-dom';
import { useCategories } from '../../../hooks/useCategories';
import Department from '../../../ui/components/Department';
import { useEffect, useMemo } from 'react';

const LandingHeader = ({ isDropdownOpen, setIsDropdownOpen }) => {
  const { categories, isLoading } = useCategories();

  useEffect(() => {
    if (isDropdownOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isDropdownOpen]);

  const sortedCategories = useMemo(
    () => categories?.slice().sort((a, b) => a.id - b.id),
    [categories]
  );

  const comingSoonCategories = ['Automotive', 'Education & Training'];
  const isComingSoon = (name) => comingSoonCategories.includes(name);

  return (
    <div className="px-5 py-3 fixed md:top-[4.5rem] top-[7.7rem] z-20 bg-white w-full">
      <div className="overflow-x-auto">
        <nav className="flex gap-9 px-4 py-2 whitespace-nowrap items-center text-sm w-fit">
          <div className="hidden md:block">
            <Department
              isDropdownOpen={isDropdownOpen}
              setIsDropdownOpen={setIsDropdownOpen}
            />
          </div>
          {isLoading
            ? Array.from({ length: 6 }).map((_, index) => (
                <div
                  key={index}
                  className="h-5 w-20 bg-gray-200 rounded animate-pulse flex-shrink-0"
                />
              ))
            : categories?.map((cat) => {
                const disabled = isComingSoon(cat.name);
                return (
                  <NavLink
                    key={cat.id}
                    to={disabled ? '#' : `/${cat.slug}`}
                    className={({ isActive }) => {
                      const baseClasses = 'hover:text-[#737376] flex-shrink-0';
                      const activeClasses =
                        disabled || !isActive ? '' : 'font-semibold underline';
                      const salesClass =
                        cat.slug.toLowerCase() === 'sales-offers'
                          ? 'text-[#DB1C5E]'
                          : '';
                      return `${baseClasses} ${activeClasses} ${salesClass}`;
                    }}
                    aria-disabled={disabled}
                    tabIndex={disabled ? -1 : 0}
                    aria-label={
                      disabled
                        ? `${cat.name} (Coming soon, currently disabled)`
                        : cat.name
                    }
                  >
                    {disabled ? (
                      <li className="md:flex relative group">
                        <span className="pointer-events-none opacity-50 cursor-not-allowed">
                          {cat.name}
                        </span>
                        {/* Tooltip */}
                        <div className="absolute left-1/2 -translate-x-1/2 text-black -top-4 text-xs bg-[#FFDE11] px-3 py-[2px] rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap z-30">
                          <span>Coming soon</span>
                          <div className="absolute left-1/2 -translate-x-1/2 top-full w-2 h-2 bg-[#FFDE11] rotate-45"></div>
                        </div>
                      </li>
                    ) : (
                      cat.name
                    )}
                  </NavLink>
                );
              })}
        </nav>
      </div>
    </div>
  );
};

export default LandingHeader;
